import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'cipher' }
    },
    {
      path: '/cipher',
      name: 'cipher',
      component: () => import('@/views/cipher/index.vue')
    },
    {
      path: '/format',
      name: 'format',
      component: () => import('@/views/format/index.vue')
    },
    {
      path: '/gpt',
      name: 'GPT',
      component: () => import('@/views/gpt/index.vue')
    },
  ]
})
